<script setup>
import InputLabel from '@/Components/FormElements/InputLabel.vue'
import { computed } from 'vue'
import InputError from './InputError.vue'

const emit = defineEmits(['update:checked'])

const props = defineProps({
    checked: {
        type: [Array, Boolean],
        default: false,
    },
    value: {
        type: String,
        default: null,
    },
    label: {
        type: String,
        default: null,
    },
    id: {
        type: String,
        required: true,
    },
    required: {
        type: Boolean,
        default: false,
    },
    error: {
        type: String,
        default: null,
    },
})

const proxyChecked = computed({
    get() {
        return props.checked
    },

    set(val) {
        emit('update:checked', val)
    },
})
</script>

<template>
    <div class="w-full space-y-2">
        <InputLabel
            :id="id"
            :value="label"
            :required="required"
            class="flex items-center cursor-pointer"
        >
            <template #checkbox-slot>
                <input
                    :id="id"
                    v-model="proxyChecked"
                    type="checkbox"
                    :value="value"
                    class="w-6 h-6 me-2 cursor-pointer rounded border-border text-primary shadow-sm focus:ring-0 transition duration-input-active"
                />
            </template>
            <slot name="checkbox-label" />
        </InputLabel>
        <InputError :message="error" />
    </div>
</template>
